module.exports = __webpack_public_path__ + "src/assets/img/herocta--dsk.f30df12e.png";